const defaultWidth = 40;
const defaultHeight = 40;

export const CloudUploadIcon = ({
  width = defaultWidth,
  height = defaultHeight,
  color = '#8B95A1',
}: SvgProps) => (
  <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <g transform={`scale(${width / defaultWidth}, ${height / defaultHeight})`}>
      <path
        d="M20 8C15.58 8 11.94 11.01 11.18 15.03C7.84 15.29 5.2 18.1 5.2 21.5C5.2 25.08 8.12 28 11.7 28H18V22.83L15.71 25.12C15.32 25.51 14.69 25.51 14.3 25.12C13.91 24.73 13.91 24.1 14.3 23.71L19.3 18.71C19.69 18.32 20.32 18.32 20.71 18.71L25.71 23.71C26.1 24.1 26.1 24.73 25.71 25.12C25.32 25.51 24.69 25.51 24.3 25.12L22 22.83V28H29.5C32.54 28 35 25.54 35 22.5C35 19.46 32.54 17 29.5 17H28.8C28.04 11.83 23.5 8 20 8Z"
        fill={color}
      />
      <path d="M18 28H22V33C22 33.55 21.55 34 21 34H19C18.45 34 18 33.55 18 33V28Z" fill={color} />
    </g>
  </svg>
);

CloudUploadIcon.displayName = 'CloudUploadIcon';
